const es: Record<string, string> = {
  "Virtual Try-On": "Probador Virtual",
  "Find Your Size & See It On You": "Encuentra tu talla y pruébatelo",
  "See Your Fit": "Ver tu ajuste",
  "Check your size, then try it on virtually": "Comprueba tu talla y pruébatelo virtualmente",
  "Get Your Size": "Tu talla",
  "Instant fit suggestion": "Sugerencia de ajuste instantánea",
  "Try It On": "Pruébatelo",
  "See how it looks on you": "Mira cómo te queda",
  "Find My Size": "Encontrar mi talla",
  "Takes less than a minute": "Tarda menos de un minuto",
  "Upload a full body photo": "Sube una foto de cuerpo entero",
  "JPEG, PNG or WebP (max 10MB)": "JPEG, PNG o WebP (máx. 10MB)",
  "Your photo": "Tu foto",
  "Let's find your best fit": "Encontremos tu mejor ajuste",
  "Centimeters": "Centímetros",
  "Inches": "Pulgadas",
  "Load saved profile...": "Cargar perfil guardado...",
  "HEIGHT": "ALTURA",
  "WEIGHT": "PESO",
  "feet": "pies",
  "inches": "pulgadas",
  "cm": "cm",
  "kg": "kg",
  "lbs": "libras",
  "in": "pulg",
  "How to measure": "Cómo medir",
  "Hide guide": "Ocultar guía",
  "I know my measurements": "Conozco mis medidas",
  "Not sure? Use height & weight instead": "¿No estás seguro? Usa altura y peso",
  "Please fill in height and weight": "Por favor, introduce altura y peso",
  "Please fill in all required fields": "Por favor, completa todos los campos obligatorios",
  "Next": "Siguiente",
  "Analyzing your size...": "Analizando tu talla...",
  "SUGGESTED SIZE": "TALLA SUGERIDA",
  "NOT SUGGESTED": "NO SUGERIDA",
  "Edit measurements": "Editar medidas",
  "Size guide": "Guía de tallas",
  "Your fit": "Tu ajuste",
  "Your Suggested Size": "Tu talla sugerida",
  "Your measure": "Tu medida",
  "within range": "dentro del rango",
  "too tight": "demasiado ajustado",
  "tight": "ajustado",
  "a bit tight": "un poco ajustado",
  "too loose": "demasiado holgado",
  "loose": "holgado",
  "a bit loose": "un poco holgado",
  "See fit on your photo": "Ver ajuste en tu foto",
  "Hide visual fit": "Ocultar ajuste visual",
  "Analyzing...": "Analizando...",
  "Try it on": "Pruébatelo",
  "SIZE CHART": "TABLA DE TALLAS",
  "YOUR ESTIMATED MEASUREMENTS": "TUS MEDIDAS ESTIMADAS",
  "Edit": "Editar",
  "Download": "Descargar",
  "Size chart": "Tabla de tallas",
  "Preparing your image...": "Preparando tu imagen...",
  "Analyzing body proportions...": "Analizando proporciones corporales...",
  "Matching garment to your photo...": "Ajustando la prenda a tu foto...",
  "Generating virtual try-on...": "Generando probador virtual...",
  "Refining details...": "Refinando detalles...",
  "Almost there...": "Casi listo...",
  "Complete!": "¡Completado!",
  "This usually takes 15-25 seconds": "Normalmente tarda 15-25 segundos",
  "Something went wrong": "Algo salió mal",
  "Try Again": "Intentar de nuevo",
  "We couldn't find a matching size for you": "No pudimos encontrar una talla adecuada para ti",
  "Please try the manual measurement screen so we can calculate your fit from your measurements.": "Prueba la pantalla de medidas manuales para que podamos calcular tu ajuste con tus medidas.",
  "Try manual measurements": "Probar medidas manuales",
  "SDK not configured. Please provide an API key.": "SDK no configurado. Por favor, proporciona una clave API.",
  "Please upload a JPEG, PNG, or WebP image.": "Por favor, sube una imagen JPEG, PNG o WebP.",
  "Image must be under 10MB.": "La imagen debe ser menor de 10MB.",
  "Try-on generation failed": "Error al generar la prueba",
  "Failed to start try-on": "Error al iniciar la prueba",
  "No product image found. Please set the product-image attribute.": "No se encontró imagen del producto. Configura el atributo product-image.",
  "Powered by": "Desarrollado por",
  "My Profiles": "Mis Perfiles",
  "History": "Historial",
  "No saved profiles yet.": "No hay perfiles guardados.",
  "No history yet.": "No hay historial aún.",
  "Product": "Producto",
  "Women's": "Mujer",
  "Men's": "Hombre",
  "Profiles": "Perfiles",
  "Women's Profile": "Perfil de Mujer",
  "Men's Profile": "Perfil de Hombre",
  "Height": "Altura",
  "Weight": "Peso",
  "Chest": "Pecho",
  "Bust": "Busto",
  "Waist": "Cintura",
  "Hips": "Caderas",
  "Shoulders": "Hombros",
  "Sleeve": "Manga",
  "Inseam": "Entrepierna",
  "Neck": "Cuello",
  "Foot": "Pie",
  "Shoe EU": "Zapato EU",
  "Shoe US": "Zapato US",
  "Shoe UK": "Zapato UK",
  "Saved": "Guardado",
  "Delete Profile": "Eliminar Perfil",
  "Shoe size (US)": "Talla de zapato (US)",
  "Shoe size (UK)": "Talla de zapato (UK)",
  "Shoe size (EU)": "Talla de zapato (EU)",
  "Generating...": "Generando...",
  "Foot length": "Longitud del pie",
  "Size": "Talla",
  "Try on size": "Probar talla",
  "e.g.": "ej.",
  "Drop your photo here or click to upload": "Arrastra tu foto aquí o haz clic para subir",
  "This usually takes 15-20 seconds": "Normalmente tarda 15-20 segundos",
  "Try-on result": "Resultado de la prueba",
  "Try Another": "Probar otra",
  "Back": "Atrás",
  "You": "Tú",
  "Garment": "Prenda",
  "Your Height": "Tu Altura",
  "Your Weight": "Tu Peso",
  "Drag or scroll to set your height": "Arrastra o desplaza para establecer tu altura",
  "Drag or scroll to set your weight": "Arrastra o desplaza para establecer tu peso",
  "Enter height and weight first": "Introduce primero altura y peso",

  // ── Field labels ──
  "Lens Width": "Ancho de lente",
  "Bridge": "Puente",
  "Arm Length": "Largo del brazo",
  "Head Circumference": "Contorno de cabeza",
  "Face Width": "Ancho de cara",
  "Temple": "Patilla",
  "Around widest point": "Alrededor del punto más ancho",
  "Foot Length": "Longitud del pie",
  "Shoulder": "Hombro",
  "Thigh": "Muslo",
  "Hip": "Cadera",

  // ── Units ──
  "Millimetre": "Milímetro",
  "Centimetre": "Centímetro",
  "Millimeters": "Milímetros",

  // ── Fit descriptors ──
  "Tight": "Ajustado",
  "Loose": "Holgado",
  "Short": "Corto",
  "Long": "Largo",
  "✓ Fit": "✓ Ajuste",
  "too short": "demasiado corto",
  "too long": "demasiado largo",
  "a bit short": "un poco corto",
  "a bit long": "un poco largo",

  // ── Length pills ──
  "Length": "Largo",
  "Length Adjustment": "Ajuste de largo",
  "Regular": "Regular",
  "Big": "Grande",
  "Big & Tall": "Grande y alto",

  // ── Misc ──
  "preview": "vista previa",

  // ── BodyProfileView — photo upload area (left section) ──
  "Upload your photo": "Sube tu foto",
  "Upload a photo": "Subir una foto",
  "Click or drag a full-body photo": "Haz clic o arrastra una foto de cuerpo entero",
  "Or upload a photo for AI sizing": "O sube una foto para análisis con IA",
  "Photo": "Foto",
  "How to take a good photo": "Cómo tomar una buena foto",
  "How to take the best photo": "Cómo tomar la mejor foto",
  "Do": "Sí",
  "Don't": "No",
  "Quick Tip": "Consejo rápido",
  "The simpler your photo is, the more accurate your virtual try-on results will be.": "Cuanto más sencilla sea tu foto, más precisos serán los resultados del probador virtual.",
  "Choose a plain background (a light wall is ideal)": "Elige un fondo liso (una pared clara es ideal)",
  "Stand facing the camera with your full body in frame": "Ponte de frente a la cámara con todo tu cuerpo en cuadro",
  "Stand straight and still, arms relaxed by your sides": "Mantente recto e inmóvil, con los brazos relajados a los lados",
  "Stand with your HEELS against a wall for best accuracy": "Coloca los TALONES contra una pared para mayor precisión",
  "Use natural or even lighting (e.g. near a window)": "Usa luz natural o uniforme (p. ej. cerca de una ventana)",
  "Wear fitted, simple clothing (e.g. neutral colors)": "Usa ropa ajustada y sencilla (p. ej. colores neutros)",
  "Don't wear loose, baggy, or layered clothing": "No uses ropa holgada, suelta o con varias capas",
  "Don't sit, pose, or bend your body": "No te sientes, poses ni dobles el cuerpo",
  "Don't use strong backlighting": "No uses contraluz fuerte",
  "Don't take mirror photos or selfies": "No tomes fotos de espejo ni selfies",
  "Don't apply filters, effects, or edits": "No apliques filtros, efectos ni ediciones",

  // ── Age gate ──
  "Are you 18 or older?": "¿Tienes 18 años o más?",
  "Yes": "Sí",
  "No": "No",
  "Please confirm your age": "Por favor confirma tu edad",
  "Please confirm that the person in the photo is 18 or older before uploading.": "Por favor confirma que la persona en la foto tiene 18 años o más antes de subirla.",
  "Under 18 — can't process this photo.": "Menor de 18 años — no se puede procesar esta foto.",
  "This photo appears to be of a minor. Please upload a photo of someone 18 or older.": "Esta foto parece ser de un menor. Sube una foto de una persona de 18 años o más.",
  "Different photo needed": "Necesitas otra foto",
  "Try another photo": "Probar otra foto",

  // ── Photo step controls ──
  "Continue": "Continuar",
  "Analyze My Size": "Analizar mi talla",
  "Analyzing photo…": "Analizando foto…",
  "Details": "Detalles",
  "Image must be under 10MB": "La imagen debe ser menor de 10MB",
  "Please upload an image file": "Sube un archivo de imagen",
  "Please upload a photo": "Sube una foto",
  "Prefer not to upload a photo?": "¿Prefieres no subir una foto?",
  "Enter measurements manually": "Introducir medidas manualmente",
  "Legal Notice": "Aviso Legal",
  "Your image will be used to generate a virtual try-on preview showing how selected items may look and fit. Images are processed securely and are not stored after generation.": "Tu imagen se utilizará para generar una vista previa del probador virtual que muestra cómo pueden verse y ajustarse los artículos seleccionados. Las imágenes se procesan de forma segura y no se almacenan después de la generación.",

  // ── BodyProfileView — form (right section) ──
  "Body details": "Detalles del cuerpo",
  "Your body details": "Tus datos corporales",
  "Body Measurements": "Medidas corporales",
  "AGE": "EDAD",
  "years": "años",
  "Enter your height": "Introduce tu altura",
  "Enter your weight": "Introduce tu peso",
  "Enter your bra size": "Introduce tu talla de sujetador",
  "Please enter your height": "Introduce tu altura",
  "Please enter your weight": "Introduce tu peso",
  "Please enter a valid height": "Introduce una altura válida",
  "Please enter a valid weight": "Introduce un peso válido",
  "Please enter a valid height (100-250 cm)": "Introduce una altura válida (100-250 cm)",
  "Please enter a valid weight (30-300 kg)": "Introduce un peso válido (30-300 kg)",
  "Please select both band and cup size": "Selecciona la talla de banda y copa",
  "Select your bra size": "Selecciona tu talla de sujetador",
  "BAND": "BANDA",
  "BAND SIZE": "TALLA DE BANDA",
  "CUP": "COPA",
  "CUP SIZE": "TALLA DE COPA",
  "BRA REGION": "REGIÓN DEL SUJETADOR",
  "Imperial": "Imperial",
  "Metric": "Métrico",
  "These calibrate the AI — all required.": "Estos calibran la IA — todos obligatorios.",
  "Using": "Usando",
  "start fresh": "empezar de nuevo",
  "Close": "Cerrar",

  // ── Body shape questions ──
  "Which best describes your chest?": "¿Cuál describe mejor tu pecho?",
  "WHICH BEST DESCRIBES YOUR CHEST?": "¿CUÁL DESCRIBE MEJOR TU PECHO?",
  "Which best describes your hips?": "¿Cuál describe mejor tus caderas?",
  "WHICH BEST DESCRIBES YOUR HIPS?": "¿CUÁL DESCRIBE MEJOR TUS CADERAS?",
  "Which best describes your midsection?": "¿Cuál describe mejor tu cintura?",
  "WHICH BEST DESCRIBES YOUR MIDSECTION?": "¿CUÁL DESCRIBE MEJOR TU CINTURA?",
  "Which best describes your seat?": "¿Cuál describe mejor tu trasero?",
  "WHICH BEST DESCRIBES YOUR SEAT?": "¿CUÁL DESCRIBE MEJOR TU TRASERO?",
  "Average": "Media",
  "Narrow": "Estrecho",
  "Broad": "Ancho",
  "Curvy": "Curvilíneo",
  "A slimmer, narrower chest build": "Un pecho más delgado y estrecho",
  "A moderate, proportionate chest": "Un pecho moderado y proporcionado",
  "A wider, more muscular chest": "Un pecho más ancho y musculoso",
  "A flatter midsection with minimal protrusion": "Una cintura más plana con mínima protuberancia",
  "A moderate, natural midsection shape": "Una cintura moderada y natural",
  "A fuller, more rounded midsection": "Una cintura más llena y redondeada",
  "A flatter backside with less projection": "Un trasero más plano con menos proyección",
  "A moderate, natural backside shape": "Un trasero moderado y natural",
  "A fuller, more rounded backside": "Un trasero más lleno y redondeado",

  // ── Photo step — profile photo preload pill ──
  "Loaded from profile": "Cargada del perfil",
  "Clear": "Borrar",
};
export default es;
